var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ele-form-dialog',{attrs:{"formDesc":_vm.formDesc,"visible":_vm.visible,"dialogAttrs":{
    'append-to-body': true
  },"formBtns":_vm.formBtns,"title":"新增校检规则"},on:{"request":_vm.handleAddRule,"update:visible":_vm.toggleDialog},model:{value:(_vm.formData),callback:function ($$v) {_vm.formData=$$v},expression:"formData"}})}
var staticRenderFns = []

export { render, staticRenderFns }